import Vue from 'vue'
import Vuex from 'vuex'
import getters from "./getters"

Vue.use(Vuex)

const moduleFiles = require.context('./modules', true, /\.js$/)
const modules = moduleFiles.keys().reduce((item, path) => {
  let name = path.replace(/^\.\/(.*)\.\w+$/, '$1')
  const value = moduleFiles(path)
  item[name] = value.default
  return item
}, {})

export default new Vuex.Store({
  modules,
  getters,
  strict: process.env.NODE_ENV !== 'production'
})
